import { render, staticRenderFns } from "./CarrierSidebar.vue?vue&type=template&id=93f3e4ba&scoped=true&"
import script from "./CarrierSidebar.vue?vue&type=script&lang=js&"
export * from "./CarrierSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CarrierSidebar.vue?vue&type=style&index=0&id=93f3e4ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f3e4ba",
  null
  
)

export default component.exports